import { EngineerValidateSuccess, Stub } from '@/shared';
import { OperationAlertProps } from './alert.types';

export const OperationFillAlert = ({ stepId, operationName }: OperationAlertProps) => {
	return (
		<Stub
			icon={<EngineerValidateSuccess />}
			header="Операция заполнена"
			label={
				<p>
					Информация по операции{' '}
					<strong>
						{stepId}
						{operationName ? ` —  ${operationName}` : null}
					</strong>{' '}
					успешно сохранена
				</p>
			}
		/>
	);
};
